/**
 * @generated SignedSource<<484fa77f161b641690181de080f853af>>
 * @relayHash 1ce8acea6682da39223e50d1097bbd01
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5bbf63e1af0eaf86bd47dbfb9b0f08cfb653355c87498b03039cbc350713b1ed

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ServiceHubsPageQuery } from './ServiceHubsPageQuery.graphql';

const node: PreloadableConcreteRequest<ServiceHubsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "5bbf63e1af0eaf86bd47dbfb9b0f08cfb653355c87498b03039cbc350713b1ed",
    "metadata": {},
    "name": "ServiceHubsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
